import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function BranchPicker({ value, onChange }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const canPick = ["vp", "zh", "admin", "aho", "azh", "md"].includes(user.role);
  useEffect(() => {
    if (canPick) api.get("/branches").then((r) => setBranches(r.data)).catch(() => {});
  }, [canPick]);
  if (!canPick) return null;
  return (
    <select data-testid="branch-picker" value={value || ""} onChange={(e) => onChange(e.target.value || null)}
      className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#0E2240]">
      <option value="">All branches</option>
      {branches.map((b) => <option key={b.id} value={b.id}>{b.dealer_code ? `${b.dealer_code} — ${b.name}` : b.name}</option>)}
    </select>
  );
}
